/* eslint-disable max-lines-per-function */
import { Button, FieldError } from '@e2n/ui';
import {
  InputFormField,
  TimeInputFormField,
} from '@/domain/termine/features/CreateTermin/Sheet/components';
import { ImageFormField } from '@/domain/termine/features/CreateTermin/Sheet/components/FormFields/ImageFormField';
import { TextAreaFormField } from '@/domain/termine/features/CreateTermin/Sheet/components/FormFields/TextAreaFormField';
import { CalendarSelectFormField } from '@/domain/termine/features/CreateTermin/shared/FormFields/CalendarSelectFormField';
import { ColorPickerFormField } from '@/domain/termine/features/CreateTermin/shared/FormFields/ColorPickerFormField';
import { DatePickerFormField } from '@/domain/termine/features/CreateTermin/shared/FormFields/DatePickerFormField';
import { RepetitionIntervalFormField } from '@/domain/termine/features/CreateTermin/shared/RepetitionIntervalFormField';
import { useCreateTermineFormContext } from '@/domain/termine/features/CreateTermin/shared/useCreateTermineFormContext';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export function CreateTermineFormContent() {
  const { t } = useTranslation();
  const { form } = useCreateTermineFormContext();
  const [showSpecials, setShowSpecials] = useState(false);

  return (
    <div className="flex flex-col gap-4 p-6 pb-24">
      <span className="font-normal text-neutrals-700 text-xs">
        {t('domain.termine.sheet.pflichtfelder')}
      </span>
      <div className="flex flex-col flex-1 gap-4">
        <ImageFormField />
        <div className="flex flex-col gap-4 flex-1">
          <div className="flex gap-4 items-start">
            <InputFormField />
            <ColorPickerFormField />
          </div>

          <div className="flex flex-col md:flex-row gap-4">
            <DatePickerFormField name="datum" />
            <div className="flex flex-col">
              <div className="flex gap-4">
                <TimeInputFormField name="beginn" />
                <TimeInputFormField name="ende" />
              </div>
              <form.Subscribe selector={(state) => [state.fieldMeta]}>
                {([fieldMeta]) => {
                  const timeErrors =
                    fieldMeta.beginn?.errors ?? fieldMeta.ende?.errors;
                  return <FieldError errors={timeErrors} />;
                }}
              </form.Subscribe>
            </div>
          </div>
          <RepetitionIntervalFormField />
          <CalendarSelectFormField />
          <TextAreaFormField name="beschreibung" />
          {!showSpecials && (
            <Button
              type="button"
              variant="ghost-primary"
              className="self-start w-auto"
              onClick={() => setShowSpecials(true)}>
              <span className="text-sm">
                {t('domain.termine.addAdditionalInformation')}
              </span>
            </Button>
          )}
          {showSpecials && <TextAreaFormField name="specials" />}
        </div>
      </div>
    </div>
  );
}
